import { Navigate, useLocation } from 'react-router-dom';// Temporary restriction: remove when organisation 4629 requests that it be undone.
import { canAccessSettingsPath } from './utils/settingsAccess';// Temporary restriction: remove when organisation 4629 requests that it be undone.
import { LocalStorage } from './utils/storage/local-storage';
import { CommonHelper } from './utils/commonHelper';

const PrivateRouteComponent = ({ children, permissions }) => {
  // Temporary restriction: remove when organisation 4629 requests that it be undone.
  const { pathname } = useLocation();
  let authUser = LocalStorage.getItem('token');
  let isRouteLoaded = LocalStorage.getItem('isRouteLoaded');
  if (authUser) {
    if (isRouteLoaded && JSON.parse(isRouteLoaded)) {
      // Temporary restriction: remove when organisation 4629 requests that it be undone.
      if (!canAccessSettingsPath(pathname)) {
        return <Navigate to="/profile" replace />;
      }
      if (permissions) {
        let permissionObj = CommonHelper.GetBrandInfoFromLocalStorage('permissions');
        if (permissionObj && permissionObj[permissions]) {
          return children;
        } else {
          return <Navigate to={CommonHelper.DefaultPermissionRoute} />;
        }
      } else {
        //If permission is empty then the route is no-brand, no-organization
        return <Navigate to="/no-brand" />;
      }
    }
  } else {
    return <Navigate to="/login" />;
  }
};
export default PrivateRouteComponent;
